import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-global-spinner',
    templateUrl: './global-spinner.component.html',
    styleUrls: ['./global-spinner.component.scss'],
    standalone: false
})
export class GlobalSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
